import classNames from 'classnames'

export default function Container({
  children,
  className,
}: {
  children: React.ReactNode
  className?: string
}) {
  return <div className={classNames('container', className)}>{children}</div>
}
